var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"reset-pwd-email"},[_c('div',{staticClass:"email-wrap tc"},[_c('p',{staticClass:"desc"},[_vm._v("A reset password Email has been sent to you")]),_vm._v(" "),_c('p',[_vm._v("Please check your inbox for an email")]),_vm._v(" "),_c('p',{staticClass:"link-btn",on:{"click":_vm.handleSendemial}},[_vm._v("resend email")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }